module.exports = __webpack_public_path__ + "img/thumb6.4a3f17ca.png";